import { useEffect } from 'react';
import { App as AntApp } from 'antd';
import { setNotificationApi } from '../../helpers/notifications/notificationService';

const NotificationHost = () => {
  const { notification } = AntApp.useApp();

  useEffect(() => {
    setNotificationApi(notification);

    return () => {
      setNotificationApi(null);
    };
  }, [notification]);

  return null;
};

export default NotificationHost;
